/*! @azure/msal-browser v4.5.1 2025-03-04 */
'use strict';

/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.5.1";
export { name, version };